import { Component } from "react";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitionDrawer from "../../../../../common_components/admin_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import Modal from "react-modal";

import {
  getDefaultFurnitureAgencyDetails_action,
  insertUpdateAdditionalFurniture_action
} from "../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/additionalFurniture_action/additionalFurniture_action";

import { getStallDesignDetails_action } from "../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/stallDesign_action/stallDesign_action";

import {
  BASE_URL,
  DOC_BASE_URL,
  formatAmount,
  toastError,
  toastSuccess
} from "../../../../../utils/constants";

import moment from "moment";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";


class AdditionalFurniture extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,

      confirmationObj: {
        message: "",
        buttonName: "",
        action: ""
      },

      popArg: [],
      isOpenConfirmationModal: false,

      imageFilePath: "",
      isOpen: false,

      ExhibitorData: [],
      ShellTableData: [],
      ItemData: [],

      FurnitureDetailsFilePath: "",

      ExhibitorName: "",
      StallName: "",
      HallName: "",
      OpenSides: "",
      StallArea: "",
      StallTypeName: "",
      Remark: "",

      AdditionalFurnitureHdrID: 0,

      DeadlineDate: "",

      currentDate: moment().format("DD-MM-YYYY"),

      Is_View:
        this.props.location.state != null &&
          this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1,

      isHideSection:
        sessionStorage.getItem("RoleIDSS") != 1 &&
        sessionStorage.getItem("RoleIDSS") != 8,

      StatusID: "",

      // ----------------------------------
      // GST / Currency
      // ----------------------------------
      CurrencyID: 1,
      IsIGST: 0
    };

    console.log("pppp", this.props);

    this.toggleModal = this.toggleModal.bind(this);
    this.handleConfirmation = this.handleConfirmation.bind(this);
  }


  // =========================================================
  // CONFIRMATION
  // =========================================================

  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;

    if (flag) {
      if (confirmationObj.action == 0) {
        this.handleSave();
      }
    }

    this.setState({
      isOpenConfirmationModal: false
    });
  }


  // =========================================================
  // COMPONENT DID MOUNT
  // =========================================================

  componentDidMount() {
    this.getDefaultFurnitureAgencyDetails();
    this.getStallDesignDetails();

    this.setState({
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",

      is_View:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1,

      StatusID:
        this.props.location.state != null &&
          this.props.location.state.StatusID != null
          ? this.props.location.state.StatusID
          : ""
    });
  }


  // =========================================================
  // GET DEFAULT FURNITURE DETAILS
  // =========================================================

  getDefaultFurnitureAgencyDetails() {

    this.setState({
      isLoading: true
    });

    this.props
      .getDefaultFurnitureAgencyDetails_action()
      .then((data) => {

        console.log("Default Furniture API Response:", data);

        if (data.error != 1) {

          const gstData =
            Array.isArray(data.GST) && data.GST.length > 0
              ? data.GST[0]
              : {};

          const currencyID =
            gstData.CurrencyID != null
              ? gstData.CurrencyID
              : 1;

          const isIGST =
            gstData.IsIGST != null
              ? gstData.IsIGST
              : 0;


          this.setState({
            isLoading: false,

            ExhibitorData:
              Array.isArray(data.ExhibitorData)
                ? data.ExhibitorData
                : [],

            ShellTableData:
              Array.isArray(data.ShellTableData)
                ? data.ShellTableData.filter(item => item.DeskTable || item.Chairs || item.DustBins || item.PlugPoints || item.RoundTable || item.SinglePhasePower || item.SpotLights)
                : [],

            ItemData:
              Array.isArray(data.ItemData)
                ? data.ItemData
                : [],

            AdditionalFurnitureHdrID:
              data.ItemData &&
                data.ItemData.length > 0
                ? data.ItemData[0]?.AdditionalFurnitureHdrID || 0
                : 0,

            Remark:
              data.ItemData &&
                data.ItemData.length > 0
                ? data.ItemData[0]?.Remark || ""
                : "",

            // GST / Currency
            CurrencyID: currencyID,
            IsIGST: isIGST
          });

          console.log("CurrencyID:", currencyID);
          console.log("IsIGST:", isIGST);

        } else {

          this.setState({
            isLoading: false
          });

          toastError(data.msg);
        }

      })
      .catch((e) => {

        console.log(e);

        this.setState({
          isLoading: false
        });
      });
  }


  // =========================================================
  // GET STALL DESIGN DETAILS
  // =========================================================

  getStallDesignDetails() {

    this.setState({
      isLoading: true
    });

    this.props
      .getStallDesignDetails_action()
      .then((data) => {

        if (data.error != 1) {

          this.setState({
            isLoading: false,

            ExhibitorName:
              data.data[0]["ExhibitorName"] || "-",

            StallName:
              data.data[0]["StallName"] || "-",

            HallName:
              data.data[0]["HallName"] || "-",

            OpenSides:
              data.data[0]["OpenSides"] || "-",

            StallArea:
              data.data[0]["StallArea"] || "-",

            StallTypeName:
              data.data[0]["StallTypeName"] || "-"
          });

        } else {

          this.setState({
            isLoading: false
          });

          toastError(data.msg);
        }

      })
      .catch((e) => {

        console.log(e);

        this.setState({
          isLoading: false
        });
      });
  }


  // =========================================================
  // MODAL TOGGLE
  // =========================================================

  toggleModal(filePath) {

    const { isOpen } = this.state;

    this.setState({
      isOpen: !isOpen,
      imageFilePath: filePath
    });
  }


  // =========================================================
  // HANDLE QUANTITY / DAYS CHANGE
  // =========================================================

  handleInputChange(index, field, value) {

    const {
      ItemData,
      CurrencyID
    } = this.state;

    const updatedData = [...ItemData];

    updatedData[index] = {
      ...updatedData[index],
      [field]: value
    };


    // ---------------------------------------------
    // Select rate according to CurrencyID
    // CurrencyID 1 = INR
    // Other CurrencyID = USD
    // ---------------------------------------------

    const rate =
      Number(CurrencyID) === 1
        ? parseFloat(updatedData[index].INRRate) || 0
        : parseFloat(updatedData[index].USDRate) || 0;


    const quantity =
      parseFloat(updatedData[index].Quantity) || 0;


    const days =
      parseFloat(updatedData[index].Days) || 0;


    // ---------------------------------------------
    // Calculate item total
    // ---------------------------------------------

    updatedData[index].TotalAmount =
      rate * quantity * days;


    console.log("Furniture Calculation:", {
      CurrencyID,
      rate,
      quantity,
      days,
      TotalAmount: updatedData[index].TotalAmount
    });


    this.setState({
      ItemData: updatedData
    });
  }


  // =========================================================
  // SAVE
  // =========================================================

  handleSave() {

    const {
      ItemData,
      Remark,
      AdditionalFurnitureHdrID
    } = this.state;


    const ManualFormsID =
      this.props.location.state?.ManualFormsID || null;


    const ServiceID =
      this.props.location.state?.ServiceID || null;


    const VendorDetails =
      this.props.location.state?.VendorDetails || {};


    const AdditionalFurnitureList =
      ItemData
        .filter(
          item =>
            item.Quantity &&
            item.Days
        )
        .map(item => ({

          AdditionalFurnitureDtlID:
            item.AdditionalFurnitureDtlID || 0,

          MstAdditionalFurnitureID:
            item.MstAdditionalFurnitureID,

          Quantity:
            item.Quantity,

          Days:
            item.Days,

          TotalAmount:
            item.TotalAmount
        }));


    console.log("=== DEBUGGING REMARK ===");

    console.log(
      "Remark from state:",
      Remark
    );

    console.log(
      "AdditionalFurnitureHdrID:",
      AdditionalFurnitureHdrID
    );

    console.log(
      "ManualFormsID:",
      ManualFormsID
    );

    console.log(
      "ServiceID:",
      ServiceID
    );

    console.log(
      "VendorDetails:",
      VendorDetails
    );

    console.log(
      "AdditionalFurnitureList:",
      AdditionalFurnitureList
    );

    console.log("========================");


    this.setState({
      isLoading: true
    });


    this.props
      .insertUpdateAdditionalFurniture_action(
        Remark,
        AdditionalFurnitureHdrID,
        AdditionalFurnitureList,
        ManualFormsID,
        ServiceID,
        VendorDetails
      )
      .then((data) => {

        console.log(
          "API Response:",
          data
        );


        this.setState({
          isLoading: false
        });


        if (data.error != 1) {

          toastSuccess(
            "Furniture saved successfully"
          );


          setTimeout(() => {

            this.props.navigate(
              "/manualForms"
            );

          }, 1000);

        } else {

          toastError(
            data.msg
          );
        }

      })
      .catch((e) => {

        console.log(e);

        this.setState({
          isLoading: false
        });
      });
  }


  // =========================================================
  // RENDER
  // =========================================================

  render() {

    const {
      isLoading,
      imageFilePath,
      isOpen,
      ExhibitorData,
      ShellTableData,
      ItemData,
      currentDate,
      DeadlineDate,
      is_View,
      isHideSection,
      isOpenConfirmationModal,
      StatusID,
      CurrencyID,
      IsIGST
    } = this.state;


    console.log(
      "CurrencyID:",
      CurrencyID
    );

    console.log(
      "IsIGST:",
      IsIGST
    );


    // =====================================================
    // DEADLINE CHECK
    // =====================================================

    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY") &&
      moment(
        currentDate,
        "DD-MM-YYYY"
      ).isAfter(
        moment(
          DeadlineDate,
          "DD-MM-YYYY"
        )
      );


    // =====================================================
    // TOTAL WITHOUT GST
    // =====================================================

    const totalWithoutGST =
      ItemData.reduce(
        (sum, item) =>
          sum +
          (parseFloat(item.TotalAmount) || 0),
        0
      );


    // =====================================================
    // GST CALCULATION
    // =====================================================

    let igstAmount = 0;
    let cgstAmount = 0;
    let sgstAmount = 0;


    if (Number(IsIGST) === 1) {

      // IGST 18%

      igstAmount =
        totalWithoutGST * 0.18;

    } else {

      // CGST 9%

      cgstAmount =
        totalWithoutGST * 0.09;


      // SGST 9%

      sgstAmount =
        totalWithoutGST * 0.09;
    }


    // =====================================================
    // GRAND TOTAL
    // =====================================================

    const grandTotal =
      totalWithoutGST +
      igstAmount +
      cgstAmount +
      sgstAmount;


    return (
      <>

        {/* =================================================
            CONFIRMATION MODAL
        ================================================= */}

        {isOpenConfirmationModal ? (
          <ConfirmationModal
            onConfirmation={
              this.handleConfirmation
            }
            message={
              this.state.confirmationObj
            }
          />
        ) : null}


        {/* =================================================
            LOADER
        ================================================= */}

        {isLoading ? (
          <Loader />
        ) : null}


        <ToastContainer />


        {/* =================================================
            HEADER
        ================================================= */}

        {!isHideSection && (
          <>
            <ExhibitorHeader />
            <ExhibitorDrawer />
          </>
        )}


        <div
          className={
            !isHideSection
              ? "with-dr-container workUpdation-top-space"
              : "workUpdation-top-space"
          }
        >

          <div>

            {/* =================================================
                TOP MENU
            ================================================= */}

            {!isHideSection && (
              <div className="row">
                <ExhibitorTopMenu />
              </div>
            )}


            <div className="row mx-2 m-0">

              <div className="card rounded-0 p-0 border shadow-none">

                {/* =================================================
                    CARD HEADER
                ================================================= */}

                <div className="card-header">

                  <h3 className="card-title">
                    Additional Furniture
                  </h3>

                </div>


                {/* =================================================
                    DEADLINE
                ================================================= */}

                {!isHideSection && (
                  <div className="row m-0">

                    <h6 className="mt-2 pt-2">

                      Additional Furniture{" "}

                      <span className="text-danger">

                        Last Date Of Submission -{" "}

                        {this.props.location?.state?.ActualDeadline
                          ? moment(
                            this.props.location.state.ActualDeadline
                          ).format("DD-MM-YYYY")
                          : "-"}

                      </span>

                    </h6>

                  </div>
                )}


                <div className="card-body pt-2">

                  <div className="row text-left">


                    {/* =================================================
                        NOTE
                    ================================================= */}

                    <h6>

                      1) Photos/Pictures of the furniture wherever given are only for
                      demonstration & not actual. List of basic furniture & fittings
                      provided on the basis of the stall area.

                    </h6>


                    {/* =================================================
                        SHELL TABLE
                    ================================================= */}

                    {ExhibitorData.length > 0 && (
                      <>

                        <div className="table-responsive m-0 p-2">

                          <table
                            className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1"
                          >

                            <thead className="table-light">

                              <tr>

                                <th>
                                  AREA IN SQM
                                </th>

                                <th>
                                  DESK TABLE
                                </th>

                                <th>
                                  ROUND TABLE
                                </th>

                                <th>
                                  CHAIRS
                                </th>

                                <th>
                                  SPOTLIGHTS
                                </th>

                                <th>
                                  PLUG POINTS
                                </th>

                                <th>
                                  DUSTBINS
                                </th>

                                <th>
                                  SINGLE PHASE POWER
                                </th>

                              </tr>

                            </thead>


                            <tbody>

                              {ShellTableData.map(
                                (item, index) => (

                                  <tr key={index}>

                                    <td>
                                      {item.AreaInSQM}
                                    </td>

                                    <td>
                                      {item.DeskTable}
                                    </td>

                                    <td>
                                      {item.RoundTable}
                                    </td>

                                    <td>
                                      {item.Chairs}
                                    </td>

                                    <td>
                                      {item.SpotLights}
                                    </td>

                                    <td>
                                      {item.PlugPoints}
                                    </td>

                                    <td>
                                      {item.DustBins}
                                    </td>

                                    <td>
                                      {item.SinglePhasePower}
                                    </td>

                                  </tr>

                                )
                              )}

                            </tbody>

                          </table>

                        </div>

                      </>
                    )}


                    {/* =================================================
                        EXHIBITOR DETAILS
                    ================================================= */}

                    {ExhibitorData.length > 0 && (
                      <>

                        <div className="p-1 bg-light border p-2">

                          <h6 className="fw-semibold">
                            Exhibitor Details
                          </h6>


                          <ul
                            className="px-1"
                            style={{
                              listStyleType: "none",
                              margin: 0
                            }}
                          >

                            <li>
                              Exhibitor Name:{" "}
                              {ExhibitorData[0].ExhibitionName}
                            </li>

                            <li>
                              Hall Name:{" "}
                              {ExhibitorData[0].HallName}
                            </li>

                            <li>
                              Stall No.:{" "}
                              {ExhibitorData[0].StallName}
                            </li>

                            <li>
                              Stall Type:{" "}
                              {ExhibitorData[0].StallTypeName}
                            </li>

                            <li>
                              Area:{" "}
                              {ExhibitorData[0].TotalArea}
                            </li>

                            <li>
                              Sides open:{" "}
                              {ExhibitorData[0].OpenSides}
                            </li>

                          </ul>

                        </div>

                      </>
                    )}

                    {/* =================================================
                        Vendor DETAILS
                    ================================================= */}

                    <div className="p-1 bg-light border p-2">

                      <h6 className="fw-semibold">
                        Service Partner Details
                      </h6>
                      <div
                        class="table-responsive w-50"
                        style={{
                          backgroundColor: "#ebebeb",
                          marginBottom: "14px",
                          borderRight: "1px solid lightgray",
                        }}
                      >
                        <div style={{ margin: "10px 0 10px 10px", lineHeight: "23px" }}>
                          <p className="m-0"><strong>Name:</strong> Mr. Sunny Sharma{" "}</p>
                          <p className="m-0"><strong>Mobile No.</strong> +918708215083/+91 9953642118</p>
                          <p className="m-0"><strong>Email:</strong> sunny.deepalidesigns@gmail.com</p>
                        </div>
                        <div style={{ margin: "10px 0 10px 10px", lineHeight: "23px" }}>
                          <p className="m-0"><strong>Name:</strong> Mr. Prince Nimesh{" "}</p>
                          <p className="m-0"><strong>Mobile No.</strong> +91 7669001045</p>
                          <p className="m-0"><strong>Email:</strong> princenimesh@deepalidesigns.com</p>
                        </div>
                        <div style={{ margin: "10px 0 10px 10px", lineHeight: "23px" }}>
                          <p className="m-0"><strong>Name:</strong> Ms. Neha  Singh{" "}</p>
                          <p className="m-0"><strong>Mobile No.</strong> +91 9711489499</p>
                          <p className="m-0"><strong>Email:</strong> Neha.singh@deepalidesigns.com</p>
                        </div>
                      </div>
                    </div>

                    {/* =================================================
                        Vendor Bank DETAILS
                    ================================================= */}

                    <div className="p-1 bg-light border p-2">

                      <h6 className="fw-semibold">
                        Service Partner Bank Details
                      </h6>
                      <div
                        class="table-responsive w-50"
                        style={{
                          backgroundColor: "#ebebeb",
                          marginBottom: "14px",
                          borderRight: "1px solid lightgray",
                        }}
                      >
                        <div style={{ margin: "10px 0 10px 10px", lineHeight: "23px" }}>
                          <p className="m-0"><strong>Bank Name:</strong> ICICI BANK{" "}</p>
                          <p className="m-0"><strong>Bank Address:</strong> Punjabi Bagh Branch, New Delhi - 110026</p>
                          <p className="m-0"><strong>Account No:</strong> 015551000021</p>
                          <p className="m-0"><strong>Person Name:</strong> Deepali Designs & Exhibits Pvt. Ltd.</p>
                          <p className="m-0"><strong>IFSC Code:</strong> ICIC0000155</p>
                        </div>
                      </div>
                    </div>

                    {/* =================================================
                        FURNITURE REQUIREMENTS
                    ================================================= */}

                    <h6 className="mt-3">
                      Furniture Requirements (Additional Orders)
                    </h6>


                    <div className="m-0">

                      <table
                        className="table border table-bordered mb-0 mt-1 p-0"
                      >

                        <thead className="table-light">

                          <tr>

                            <th
                              style={{
                                width: "40px"
                              }}
                            >
                              Sr.No
                            </th>


                            <th
                              style={{
                                width: "32%"
                              }}
                            >
                              Furniture Description / Item (Code)
                            </th>


                            <th
                              style={{
                                width: "80px"
                              }}
                            >
                              Picture
                            </th>


                            {!isHideSection && (
                              <th
                                style={{
                                  width: "40px"
                                }}
                              >
                                Rate ({CurrencyID == 1 ? 'INR' : 'USD'})
                              </th>
                            )}


                            <th
                              style={{
                                width: "50px"
                              }}
                            >
                              Quantity
                            </th>


                            <th
                              style={{
                                width: "50px"
                              }}
                            >
                              Days
                            </th>


                            {!isHideSection && (
                              <th
                                style={{
                                  width: "80px"
                                }}
                              >
                                Total Amount
                              </th>
                            )}

                          </tr>

                        </thead>


                        <tbody>


                          {/* =================================================
                              ITEM DATA
                          ================================================= */}

                          {ItemData.map(
                            (item, index) => (

                              <tr key={index}>

                                {/* SR NO */}

                                <td>
                                  {index + 1}
                                </td>


                                {/* DESCRIPTION */}

                                <td>

                                  {item.Items}{" "}

                                  ({item.Dimension})

                                </td>


                                {/* PICTURE */}

                                <td>

                                  {item.Picture && (

                                    <img
                                      src={
                                        BASE_URL +
                                        item.Picture
                                      }
                                      alt={
                                        item.Items
                                      }
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        cursor: "pointer"
                                      }}
                                      onClick={() =>
                                        this.toggleModal(
                                          BASE_URL +
                                          item.Picture
                                        )
                                      }
                                    />

                                  )}

                                </td>


                                {/* RATE */}

                                {!isHideSection && (

                                  <td
                                    style={{
                                      textAlign: "right"
                                    }}
                                  >

                                    {formatAmount(
                                      Number(CurrencyID) === 1
                                        ? item.INRRate
                                        : item.USDRate
                                    )}

                                  </td>

                                )}


                                {/* QUANTITY */}

                                <td>

                                  <input
                                    type="number"
                                    className="form-control"
                                    value={
                                      item.Quantity || ""
                                    }
                                    disabled={
                                      isDeadlinePassed ||
                                      is_View ||
                                      StatusID == 2
                                    }
                                    onChange={(e) =>
                                      this.handleInputChange(
                                        index,
                                        "Quantity",
                                        e.target.value
                                      )
                                    }
                                  />

                                </td>


                                {/* DAYS */}

                                <td>

                                  <input
                                    type="number"
                                    className="form-control"
                                    value={
                                      item.Days || ""
                                    }
                                    disabled={
                                      isDeadlinePassed ||
                                      is_View ||
                                      StatusID == 2
                                    }
                                    onChange={(e) =>
                                      this.handleInputChange(
                                        index,
                                        "Days",
                                        e.target.value
                                      )
                                    }
                                  />

                                </td>


                                {/* ITEM TOTAL */}

                                {!isHideSection && (

                                  <td
                                    style={{
                                      textAlign: "right"
                                    }}
                                  >

                                    {item.TotalAmount
                                      ? item.TotalAmount.toFixed(2)
                                      : "-"}

                                  </td>

                                )}

                              </tr>

                            )
                          )}


                          {/* =================================================
                              TOTAL WITHOUT GST
                          ================================================= */}

                          {!isHideSection && (

                            <tr>

                              <td
                                colSpan="6"
                                className="text-right fw-semibold"
                              >
                                Total
                              </td>


                              <td
                                className="fw-semibold"
                                style={{
                                  textAlign: "right"
                                }}
                              >

                                {totalWithoutGST.toFixed(2)}

                              </td>

                            </tr>

                          )}


                          {/* =================================================
                              IGST
                          ================================================= */}

                          {!isHideSection &&
                            Number(IsIGST) === 1 && (

                              <tr>

                                <td
                                  colSpan="6"
                                  className="text-right fw-semibold"
                                >
                                  IGST @ 18%
                                </td>


                                <td
                                  className="fw-semibold"
                                  style={{
                                    textAlign: "right"
                                  }}
                                >

                                  {igstAmount.toFixed(2)}

                                </td>

                              </tr>

                            )}


                          {/* =================================================
                              CGST + SGST
                          ================================================= */}

                          {!isHideSection &&
                            Number(IsIGST) !== 1 && (
                              <>

                                {/* CGST */}

                                <tr>

                                  <td
                                    colSpan="6"
                                    className="text-right fw-semibold"
                                  >
                                    CGST @ 9%
                                  </td>


                                  <td
                                    className="fw-semibold"
                                    style={{
                                      textAlign: "right"
                                    }}
                                  >

                                    {cgstAmount.toFixed(2)}

                                  </td>

                                </tr>


                                {/* SGST */}

                                <tr>

                                  <td
                                    colSpan="6"
                                    className="text-right fw-semibold"
                                  >
                                    SGST @ 9%
                                  </td>


                                  <td
                                    className="fw-semibold"
                                    style={{
                                      textAlign: "right"
                                    }}
                                  >

                                    {sgstAmount.toFixed(2)}

                                  </td>

                                </tr>

                              </>
                            )}


                          {/* =================================================
                              GRAND TOTAL
                          ================================================= */}

                          {!isHideSection && (

                            <tr>

                              <td
                                colSpan="6"
                                className="text-right fw-semibold"
                              >
                                Grand Total
                              </td>


                              <td
                                className="fw-semibold"
                                style={{
                                  textAlign: "right"
                                }}
                              >

                                {grandTotal.toFixed(2)}

                              </td>

                            </tr>

                          )}


                        </tbody>

                      </table>

                    </div>


                    {/* =================================================
                        REMARK
                    ================================================= */}

                    <div className="mt-3">

                      <div className="form-group">

                        <label>
                          Remark
                        </label>


                        <textarea
                          className="form-control"
                          rows="3"
                          value={
                            this.state.Remark
                          }
                          disabled={
                            isDeadlinePassed ||
                            is_View ||
                            StatusID == 2
                          }
                          onChange={(e) =>
                            this.setState({
                              Remark:
                                e.target.value
                            })
                          }
                          placeholder="Enter remarks here..."
                        />

                      </div>

                    </div>


                    {/* =================================================
                        NOTES
                    ================================================= */}

                    {!isHideSection && (

                      <div>

                        <p className="mb-2">
                          <strong>
                            Note
                          </strong>
                        </p>

                        <p className="mb-2">
                          1. Payment Terms: 100% advance
                        </p>

                        <p className="mb-2">
                          2. Taxes extra as applicable
                        </p>

                      </div>

                    )}


                    {/* =================================================
                        BUTTONS
                    ================================================= */}

                    {!isHideSection && (

                      <div className="mt-2 mb-2">

                        <div className="d-flex justify-content-end mt-3">


                          {/* SAVE */}

                          <button
                            className="btn btn-aqua me-2"
                            onClick={() =>
                              this.setState({
                                isOpenConfirmationModal: true,

                                confirmationObj: {
                                  message:
                                    "Do you want to Save?",

                                  buttonName:
                                    "Save",

                                  action: 0
                                },

                                popArg: []
                              })
                            }
                            disabled={
                              isDeadlinePassed ||
                              StatusID == 2
                            }
                          >
                            Save
                          </button>


                          {/* BACK */}

                          <button
                            className="btn btn-gray"
                            onClick={() =>
                              this.props.navigate(-1)
                            }
                          >
                            Back
                          </button>


                        </div>

                      </div>

                    )}

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>


        {/* =================================================
            IMAGE MODAL
        ================================================= */}

        <Modal
          isOpen={isOpen}
          onRequestClose={() =>
            this.setState({
              isOpen: false
            })
          }
        >

          <div className="modal-dialog">

            <div className="modal-content">

              <div className="modal-header p-2">

                <h5 className="modal-title">
                  Additional Furniture
                </h5>


                <button
                  type="button"
                  className="close pop-close"
                  data-dismiss="modal"
                  onClick={() =>
                    this.setState({
                      isOpen: false
                    })
                  }
                >

                  <span
                    aria-hidden="true"
                    className="pop-cancel"
                  >
                    &times;
                  </span>

                </button>

              </div>


              <div>

                <img
                  src={imageFilePath}
                  alt="Furniture"
                />

              </div>


            </div>

          </div>

        </Modal>

      </>
    );
  }
}


// =========================================================
// EXPORT
// =========================================================

export default withRouter(
  connect(null, {
    getDefaultFurnitureAgencyDetails_action,
    getStallDesignDetails_action,
    insertUpdateAdditionalFurniture_action
  })(AdditionalFurniture)
);